import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import ReduxStoreInterface from '../../interfaces/client/ReduxStore'
import NotificationInterface from '../../interfaces/client/Notification'

import { removeNotification } from '../../actions/notifications'

import parseFlightId from '../../utils/parseFlightId'
import { maxDifferenceTwoYearsBetweenDates } from '../../utils/validation'
import {
  getFieldNotification,
  getWarningNotifications,
} from '../../utils/notifications'
import infantDateOfBirthValidation from '../../utils/forms/infantDateOfBirthValidation'

import NewBookingFormInfantRow from '../../components/NewBookingFormInfantRow'

interface NewBookingFormInfantRowProps {
  passengerId: string
  showTravelClass: boolean
  isDisabled: boolean
  departureFlightId: string
  rowId: number
  readonly?: string
}

export const mapStateToProps = (
  state: ReduxStoreInterface,
  props: NewBookingFormInfantRowProps
) => {
  const passengerErrors =
    state.notifications.passengerIdsToNotificationIds[props.passengerId]
  const departureDate = parseFlightId(props.departureFlightId).date

  const hasErrors = Boolean(passengerErrors)
  const errors: NotificationInterface[] = hasErrors
    ? getWarningNotifications(
        passengerErrors.map(
          (notificationKey: string) => state.notifications.byId[notificationKey]
        )
      )
    : []

  const firstNameError = getFieldNotification(errors, 'FirstName', true)
  const lastNameError = getFieldNotification(errors, 'LastName', true)
  const dateOfBirthError = getFieldNotification(errors, 'DateOfBirth', true)

  const uploadedPassenger = state.uploadedPassengers.byId[props.passengerId]
  const uploadedInfant = uploadedPassenger
    ? uploadedPassenger.infant
    : undefined

  return {
    passengerId: props.passengerId,
    showTravelClass: props.showTravelClass,
    rowId: props.rowId,
    readonly: props.readonly,
    isDisabled: props.isDisabled,
    infantDateOfBirthValidator: maxDifferenceTwoYearsBetweenDates(
      departureDate
    ),
    firstNameError,
    lastNameError,
    dateOfBirthError,
    uploadedInfant,
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  validateInfantDateOfBirth: (
    targetElement: HTMLInputElement,
    passengerId: string,
    infantDateOfBirthValidator: Function,
    dateOfBirthError?: NotificationInterface
  ) =>
    infantDateOfBirthValidation(
      targetElement,
      passengerId,
      infantDateOfBirthValidator,
      dispatch,
      dateOfBirthError
    ),

  onChange: (notification: NotificationInterface) => {
    if (notification) {
      dispatch(removeNotification(notification.id))
    }
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewBookingFormInfantRow)
